import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { OrderContextService } from '@services/order-context/order-context.service';

export const orderContextGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const orderContext = inject(OrderContextService);
  const router = inject(Router);

  if (!orderContext.orderId()) {
    const { orderId, signerId } = route.parent!.params;
    return new RedirectCommand(router.parseUrl(`/order/${orderId}/signer/${signerId}`));
  }

  return true;
};
